/*! @azure/msal-common v7.3.0 2022-08-01 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-common";
var version = "7.3.0";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
